import { Box, Button, Grid } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import CircularProgress from "@mui/material/CircularProgress";
import { green, pink } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Select from "@mui/material/Select";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { TransitionProps } from "@mui/material/transitions";
import axios from "axios";
import jaLocale from "date-fns/locale/ja";
import moment, { MomentInput } from "moment";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { API_URL } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import ServerlessDeleteButton from "../utilComponent/ServerlessDeleteButton";
import ChooseCheckList from "../utilComponent/ChooseCheckList";
import { useLoadingOverlay } from "../../utilHooks/loadingOverlay";
import { createdConstructionNameState } from "../../globalStates/createConstructionName";
import "./style.css";
import { blackboardInfo, blackboardDataId } from '../../BlackBoardConst';
import { formatDate } from "./utils/date";

/* form modules */
import { SubmitHandler, useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const InspectionSchema = yup.object({
  inspection_worktype: yup
    .string()
    .required("必須項目です。")
    .max(50, "50文字以内で入力して下さい。"),
  inspection_kind: yup
    .string()
    .required("必須項目です。")
    .max(50, "50文字以内で入力して下さい。"),
  inspection_date: yup.string().required("必須項目です。"),
  inspection_time: yup.string().required("必須項目です。"),
  common_number: yup
    .string()
    .required("必須項目です。") // 動作不良
    .max(50, "50桁以内で入力してください。")
    .matches(/^[0-9]+$/, "半角数値で入力してください。"),
  bleach: yup.array(
    yup.object().shape({
      name: yup
        .string()
        .required("必須項目です。")
        .max(25, "25文字以内で入力してください。"),
      user_name: yup
        .string()
        .required("必須項目です。")
        .email("正しいメールアドレスの形式で入力してください。")
        .max(50, "50文字以内で入力してください。"),
    })
  ),
  inspection_remark: yup.string().max(300, "300文字以内で入力してください。"),
});





interface blackboard {
  blackboard_color: string;
  opacity_rate: number;
  font_size: string;
  font_color: string;
  character_alignment: string;
  character_placement: string;
  [key: string]: string | number;
}


interface InspectionSubmitFormType {
  inspection_worktype: string /*工種*/;
  inspection_kind: string /*種別*/;
  inspection_date: string /*実施日*/;
  inspection_time: string /*実施時間*/;
  common_number: string /*土木共通番号*/;
  bleach: Array<Charactor> /*立会者*/;
  inspection_remark: string /*備考*/;
}

interface Charactor {
  name: string;
  user_name: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "auto",
  },
  paper: {
    width: 350,
    height: 300,
    overflow: "auto",
  },
  doc_paper: {
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    margin: 3,
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  remark: {
    margin: theme.spacing(1, 0),
  },
}));

/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/


const setBlackBoardInfo = (insdata: any) => {

  /**日時をformatする */
  const formatted = formatDate(insdata.inspection_date);
  /**日時をformatする */

  /** ローカルストレージより工事名と実施会社を取得 */
  const blackboard_data = JSON.parse(localStorage.getItem("constructionData") || '{}');
  /** ローカルストレージより工事名と実施会社を取得 */


  const setBlackBoardInfo = blackboardInfo.map(info => {
    let detailData;
    const index = info.id;
    switch (index) {
      case blackboardDataId.constructionName:
        detailData = { ...info, data: blackboard_data.constructionName }
        break;
      case blackboardDataId.constructionType:
        detailData = { ...info, data: insdata.inspection_work_type }
        break;
      case blackboardDataId.inspectionKind:
        detailData = { ...info, data: insdata.inspection_kind }
        break;
      case blackboardDataId.commonNumber:
        detailData = { ...info, data: insdata.common_number };
        break;
      case blackboardDataId.date:
        detailData = { ...info, data: formatted };
        break;
      case blackboardDataId.company:
        detailData = { ...info, data: blackboard_data.userName }
        break;
      default:
        throw new Error('不明なIDです');
    }
    return detailData;
  })

  return setBlackBoardInfo;
}

/*転送リスト*/

function not(a: any, b: any) {
  return a.filter((value: any) => b.indexOf(value) === -1);
}

function intersection(a: any, b: any) {
  return a.filter((value: any) => b.indexOf(value) !== -1);
}

/*転送リスト*/

// React Main Component はここから
const Inspectionedit: React.FC = () => {
  const [stateBlackBoardInfo, setStateBlackBoardInfo] = useState(blackboardInfo);
  const { openLoading, closeLoading } = useLoadingOverlay();
  // 実施日の情報を保管するuseState
  const [insDate, setInsDate] = useState<string | MomentInput | null>(null);

  /**LocalStorageからデザインデータを取得する */
  const displayBoardDesign = JSON.parse(localStorage.getItem("blackboardDesign") || '{}');
  
  /*id取得*/
  const { state } = useLocation();
  const conid = (state as any)?.conid;
  const Insid = (state as any)?.Insid;
  const actor = (state as any)?.actor;
  const witnesslist = (state as any)?.witness;
  //console.log(conid)

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [Uploading, setUpLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  /*ダイアログ処理*/

  const {
    handleSubmit,
    control,
    register,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(InspectionSchema),
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "bleach",
  });

  const [checklistActivation, setChecklistActivation] = useState();
  const [checkList, setCheckList] = useState({});
  // const [bbImgData, set_BbImgData] = React.useState();

  /*検査API*/
  const [posts, setPosts] = useState<any[]>([]);
  const [fileposts, setFilePosts] = useState<any[]>([]);
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || "{}");

  const [toastOpenFlg, setToastOpen] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");
  const toastOpen = (message: string) => {
    setToastOpen(true);
    setToastMessage(message);
  };

  // 検査情報取得API
  const inspectionGet = async () => {
    openLoading();
    await axios
      .post(
        API_URL.INSPECTION_GET,
        {
          company_id: jsonlist.user.company_id,
          dealer_info_id: jsonlist.user.dealer_info_id,
          construction_id: conid,
          inspection_info_id: Insid,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        const insdata = res.data.data;
        const editInspectionBlackBoard = setBlackBoardInfo(insdata);
        setStateBlackBoardInfo(editInspectionBlackBoard);

        // formのデフォルト値を決定する。
        setValue("inspection_worktype", insdata.inspection_work_type);
        setValue("inspection_kind", insdata.inspection_kind);
        setValue("inspection_time", insdata.inspection_time);
        setValue("common_number", insdata.common_number);
        setValue("inspection_date", insdata.inspection_date)
        setInsDate(insdata.inspection_date);
        setPosts(insdata);

        const checklist = insdata.checklist;
        setCheckList(checklist);
        setChecklistActivation((posts as any)?.checklist_activation);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  };
  useEffect(() => {
    inspectionGet();
  }, []);

  const reloadDocuments = () => {
    openLoading();
    axios
      .post(
        API_URL.DOCUMENT_LIST,
        {
          company_id: jsonlist.user.company_id,
          inspection_info_id: Insid,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        const filedata = res.data.data;
        // console.log(filedata);
        setFilePosts(filedata);
      })
      .catch((error) => {
        //let jsonObject = JSON.parse(error);
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  };

  /*ファイルDL*/
  const DLCheckSubmit = (e: any) => {
    console.log(e);

    openLoading();
    axios
      .post(
        API_URL.FILE_ONE_DOWNLOAD,
        {
          company_id: jsonlist.user.company_id,
          file_id: e,
          file_type: "3",
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        const DLurl = res.data.data;
        // console.log(DLurl);
        //console.log(Object.keys(del)[0]);
        //console.log(DLurl)
        window.open(DLurl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  };

  /** 資料削除アイコン押下時 **/
  const onClickDeleteDocumentIcon =
    ({ fileId, fileName }: { fileId: string; fileName: string }) =>
      (e: any) => {
        if (window.confirm(`【${fileName}】 を削除しますか?`)) {
          openLoading();
          axios
            .post(
              API_URL.FILE_DELETE,
              {
                construction_id: conid,
                company_id: jsonlist.user.company_id,
                dealer_info_id: jsonlist.user.company_id,
                inspection_info_id: Insid,
                file_type: "3",
                delete_file: [fileId],
              },
              { headers: { Authorization: jsonlist.token.IdToken } }
            )
            .then((response) => {
              reloadDocuments();
              toastOpen("削除に成功しました");
            })
            .catch((error) => {
              console.log("検査詳細 資料削除失敗");
              console.log(error);
            })
            .finally(() => {
              closeLoading();
            });
        }
      };

  const createdConstructionName: string = useRecoilValue(
    createdConstructionNameState
  );

  /*検査API*/

  /*ユーザーリストAPI*/
  useEffect(() => {
    openLoading();
    axios
      .post(
        API_URL.USER_LIST,
        {
          company_id: jsonlist.user.company_id,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        const users = res.data.data;
        // console.log("fetched", users);
        const users_list = [];
        for (let i in users) {
          users_list.push({
            name: users[i].user_name,
            mail_address: users[i].user_id,
          });
        }

        const actor2 = JSON.stringify(actor); //配列arr2の文字列表現
        const new_users_list = users_list.filter(
          (item) => actor2.indexOf(JSON.stringify(item)) < 0
        );
        //console.log(new_users_list)
        setRight(actor);
        setLeft(new_users_list);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  }, []);
  /*ユーザーAPI*/

  /*ダイアログ処理*/
  const [Suopen, setSuOpen] = React.useState(false);
  const handleSuOpen = () => {
    setSuOpen(true);
  };

  const handleSuClose = () => {
    setSuOpen(false);
  };

  const [Faopen, setFaOpen] = React.useState(false);
  const handleFaOpen = () => {
    setFaOpen(true);
  };

  const handleFaClose = () => {
    setFaOpen(false);
  };

  const [upFileNames, setUpFileNames] = React.useState<string[]>();
  const [Upopen, setUpOpen] = React.useState(false);
  const handleUpOpen = () => {
    setUpOpen(true);
  };

  const handleUpClose = () => {
    setUpOpen(false);
  };
  /*ダイアログ処理*/



  /*行追加削除*/
  // const [charactor, setCharactor] = useState<Charactor[]>([]);

  useEffect(() => {
    reset({
      bleach: witnesslist,
    });
  }, [reset]);
  /*行追加削除*/

  const classes = useStyles();
  const length = 2;
  const length2 = 4;

  const [personName, setPersonName] = React.useState<string[]>([]);
  const handleChangeMultiple = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { options } = event.target;
    const value: string[] = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setPersonName(value);
  };

  /*ユーザ検索*/
  const DelCheckSubmit = (e: any) => {
    handleClickOpen();
  };
  /*ユーザー検索*/

  /*転送リスト*/

  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState<any[]>([]);
  const [right, setRight] = React.useState([]);
  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value: any) => () => {
    const currentIndex = (checked as any).indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      (newChecked as any).push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight((right as any).concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const customList = (items: any) => (
    <Paper className={classes.paper}>
      <List dense component="div" role="list">
        {items.map((value: any, index: number) => {
          const labelId = `transfer-list-item-${value}-label`;
          return (
            <ListItem
              key={index}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={(checked as any).indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.name} />
              <ListItemText id={labelId} primary={value.mail_address} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Paper>
  );

  /*転送リスト*/

  /*送信GET*/

  // const [inspection_remark, set_Inspection_remark] = useState<string>("");

  const onSubmit: SubmitHandler<InspectionSubmitFormType> = (data) => {
    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/


    // POST処理
    let jsonlist = JSON.parse(localStorage.getItem("datalist") || "{}");
    openLoading();
    axios
      .post(
        API_URL.INSPECTION_UPDATE,
        {
          company_id: jsonlist.user.company_id,
          dealer_info_id: jsonlist.user.dealer_info_id,
          construction_id: conid,
          inspection_info_id: Insid,
          inspection_info_name: "aaa",
          blackboard: createdConstructionName,
          inspection_url: "Chimeの検査用URL",
          inspection_date: moment(insDate).format("YYYY/MM/DD"),
          inspection_time: data.inspection_time,
          inspection_work_type: data.inspection_worktype,
          inspection_kind: data.inspection_kind,
          common_number: data.common_number,
          inspection_status: "0",
          template: "テンプレート",
          checklist_activation: checklistActivation,
          remarks: data.inspection_remark,
          checklist: checkList,
          witness: data.bleach,
          actor: right,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        setSuccess(true);
        setLoading(false);
        handleSuOpen();
        console.log("response", res);
      })
      .catch((error) => {
        setSuccess(true);
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  };

  /*送信GET*/

  /*ファイルアップロード*/
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);

  const changeHandlerUp = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
    faile_up(false);
  };

  /*ファイルアップロード*/

  const file_name = (selectedFile as any)?.name;

  const [faile_up_get, faile_up] = useState(true);

  const upSubmit = async (e: any) => {
    openLoading();
    const uploadedFiles = await axios.post(
      API_URL.DOCUMENT_LIST,
      {
        company_id: jsonlist.user.company_id,
        inspection_info_id: Insid,
      },
      { headers: { Authorization: jsonlist.token.IdToken } }
    );
    setUpFileNames(uploadedFiles.data.data.map((file: any) => file.file_name));
    if (uploadedFiles.data.data.length >= 5) {
      handleUpOpen();
      return;
    }

    faile_up(true);
    /*スピナー*/
    if (!Uploading) {
      setSuccess(false);
      setUpLoading(true);
    }
    /*スピナー*/

    closeLoading();



    if (selectedFile) {
      const data = new FormData();

      // data.append("upload_file", link.href);
      data.append("upload_file", selectedFile);
      data.append("company_id", jsonlist.user.company_id);
      data.append("dealer_info_id", jsonlist.user.company_id);
      data.append("construction_id", conid);
      data.append("inspection_info_id", Insid);
      data.append("file_type", "3");

      // console.log(data);

      openLoading();
      axios
        .post(API_URL.FILE_UPLOAD, data, {
          headers: {
            Authorization: jsonlist.token.IdToken,
            "content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          //const failedeta = res.data;
          setSuccess(true);
          setUpLoading(false);
          handleFaOpen();
          // console.log(res);
          reloadDocuments();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          closeLoading();
        });
    }
  };


  const changeInsWorkType = (e: any) => {
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === 1 ? { ...blackboardInfo, data: e.target.value } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);
  }


  const changeCommonNumber = (e: any) => {
    /** 土木共通仕様書番号を変更する */
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === 3 ? { ...blackboardInfo, data: e.target.value } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);
  }

  const changeInsKind = (e: any) => {
    /** 種別を変更する */
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === 2 ? { ...blackboardInfo, data: e.target.value } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);
  }

  const handleChangeInspectionDate = (newValue: any) => {
    /** 実施日を変更する */
    const formattedDate = formatDate(newValue);
    const newStateBlackBoardInfo = [...stateBlackBoardInfo].map(blackboardInfo => {
      return blackboardInfo.id === 4 ? { ...blackboardInfo, data: formattedDate } : blackboardInfo
    })
    setStateBlackBoardInfo(newStateBlackBoardInfo);

    setInsDate(newValue);
  }



  const onChooeCheckSwitch = ({
    checklistActivation,
  }: {
    checklistActivation: any;
  }) => {
    setChecklistActivation(checklistActivation);
  };

  const onChooseCheckSelect = ({ checkItems }: { checkItems: any }) => {
    setCheckList(checkItems);
  };

  const bleachErrors = errors.bleach;

  return (
    <GenericTemplate title="検査編集">
      <div>
        <Dialog
          open={Suopen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleSuClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>
            {"編集が完了しました"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              component={Link}
              to={{
                pathname: "/Inspectiondetail",
                state: { conid: conid, Insid: Insid },
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={Faopen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleFaClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>
            {"アップロードが完了しました"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              onClick={handleFaClose}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={Upopen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleUpClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>
            アップロード出来るファイルは最大5つです。
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div>現在下記のファイルがアップロードされています。</div>
              <br />
              {upFileNames?.map((name) => (
                <div key={name}>・{name}</div>
              ))}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              onClick={handleUpClose}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"参加者選択"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {/*転送リスト*/}

              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                className={classes.root}
              >
                <Grid item>{customList(left)}</Grid>
                <Grid item>
                  <Grid container direction="column" alignItems="center">
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleAllRight}
                      disabled={left.length === 0}
                      aria-label="move all right"
                    >
                      ≫
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleCheckedRight}
                      disabled={leftChecked.length === 0}
                      aria-label="move selected right"
                    >
                      &gt;
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleCheckedLeft}
                      disabled={rightChecked.length === 0}
                      aria-label="move selected left"
                    >
                      &lt;
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes.button}
                      onClick={handleAllLeft}
                      disabled={right.length === 0}
                      aria-label="move all left"
                    >
                      ≪
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>{customList(right)}</Grid>
              </Grid>
              {/*転送リスト*/}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ m: 1, position: "relative" }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleClose}
                >
                  選択
                </Button>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ m: 1, position: "relative" }}></Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>

      <Stack spacing={3} margin={2}></Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="textBoxInspection">
          <Table className="tg">
            <tbody>
              <tr>
                <th className="tg-0lax">
                  <TextField
                    id="outlined-required"
                    label="工種※"
                    variant="outlined"
                    className="InsText"
                    InputLabelProps={{ shrink: true }}
                    {...register("inspection_worktype")}
                    error={"inspection_worktype" in errors}
                    helperText={errors.inspection_worktype?.message}
                    onChange={changeInsWorkType}
                  />
                </th>
                <th className="tg-0lax tw">
                  {!!(posts as any)?.checklist_activation && (
                    <ChooseCheckList
                      onSwitch={onChooeCheckSwitch}
                      onSelect={onChooseCheckSelect}
                      checkList={(posts as any)?.checklist}
                      checklistActivation={(posts as any)?.checklist_activation}
                    />
                  )}
                </th>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    id="outlined-required"
                    label="種別"
                    variant="outlined"
                    className="InsText"
                    InputLabelProps={{ shrink: true }}
                    {...register("inspection_kind")}
                    error={"inspection_kind" in errors}
                    helperText={errors.inspection_kind?.message}
                    onChange={changeInsKind}
                  />
                </td>
                <td className="tg-0lax" rowSpan={length2}>
                  <Box className="kokuban" sx={{ border: '1px solid grey' }}>

                    <Box component='div'
                      style={{ 'opacity': displayBoardDesign.opacity / 100 }}
                      className={`
                        blackboard
                        color-${displayBoardDesign.color}
                        font-color-${displayBoardDesign.fontColor}`}
                      sx={{ width: '98%' }}
                    >
                      <Box
                        component='div'
                        className={
                          `blackboard-body
                          font-size-${displayBoardDesign.fontSize}
                          ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}
                      >
                        {stateBlackBoardInfo.map((value) => {
                          return (
                            <Box
                              key={value.id}
                              component='div'
                              className={`blackboard-row ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                              <Box component='div' className={`${value.left}  ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                                <p className={
                                  `blackboard-header
                                    alignment-${displayBoardDesign.alignment}
                                    placement-${displayBoardDesign.placement}`}>
                                  {value.header}
                                </p>
                              </Box>
                              <Box component='div' className={value.right}>
                                <p className={
                                  `blackboard-data
                                    alignment-${displayBoardDesign.alignment}
                                    placement-${displayBoardDesign.placement}`}>
                                  {value.data}
                                </p>
                              </Box>
                            </Box>
                          )
                        })}
                      </Box>
                    </Box>
                  </Box>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={jaLocale}
                  >
                    <DatePicker
                      label="実施日"
                      inputFormat="yyyy/MM/dd"
                      value={insDate}
                      onChange={(newValue) => handleChangeInspectionDate(newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ shrink: true }}
                          {...register("inspection_date")}
                          error={"inspection_date" in errors}
                          helperText={errors.inspection_date?.message}
                        />
                      )}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TextField
                      id="outlined-required"
                      label="実施時間"
                      type="time"
                      variant="outlined"
                      className="InsText"
                      InputLabelProps={{ shrink: true }}
                      {...register("inspection_time")}
                      error={"inspection_time" in errors}
                      helperText={errors.inspection_time?.message}
                      sx={{ width: 150 }}
                    />
                  </LocalizationProvider>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    id="outlined-basic"
                    label="土木共通仕様書番号※"
                    variant="outlined"
                    className="InsText"
                    InputLabelProps={{ shrink: true }}
                    {...register("common_number")}
                    error={"common_number" in errors}
                    helperText={errors.common_number?.message}
                    style={{ width: 490 }}
                    onChange={changeCommonNumber}
                  />
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <FormControl sx={{ m: 0, minWidth: 320, maxWidth: 300 }}>
                    <InputLabel shrink htmlFor="select-multiple-native">
                      実施者
                    </InputLabel>
                    <Select
                      multiple
                      native
                      value={personName}
                      // @ts-ignore Typings are not considering `native`
                      onChange={handleChangeMultiple}
                      label="Native"
                      inputProps={{
                        id: "select-multiple-native",
                      }}
                    >
                      {right.map((name: any, index: number) => (
                        <option key={index} value={name}>
                          {name.name + " " + name.mail_address}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <Button
                    style={{ color: "#fff", backgroundColor: "#FFA500" }}
                    variant="contained"
                    size="small"
                    onClick={DelCheckSubmit}
                  >
                    検索
                  </Button>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    onClick={() => append({})}
                  >
                    ＋立会者追加
                  </Button>
                  <Stack spacing={3} margin={1}></Stack>
                  <div className="textBoxWit">
                    <section>
                      <table>
                        <tbody>
                          {fields.map((field, index) => (
                            <tr key={index}>
                              <td style={{ width: "70%" }}>
                                <TextField
                                  id="outlined-required"
                                  label="名前"
                                  variant="outlined"
                                  className="InsText2"
                                  multiline={true}
                                  {...register(`bleach[${index}].name`)}
                                  error={"`bleach[${index}].name`" in errors}
                                  helperText={
                                    bleachErrors &&
                                    bleachErrors[index]?.name?.message
                                  }
                                />
                                <TextField
                                  id="outlined-required"
                                  label="メールアドレス"
                                  variant="outlined"
                                  className="InsText3"
                                  multiline={true}
                                  {...register(`bleach[${index}].user_name`)}
                                  error={
                                    "`bleach[${index}].user_name`" in errors
                                  }
                                  helperText={
                                    bleachErrors &&
                                    bleachErrors[index]?.user_name?.message
                                  }
                                />
                                <ServerlessDeleteButton
                                  onClick={() => remove(index)}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </section>
                  </div>
                  <div className={classes.remark}>
                    <TextField
                      id="outlined-basic"
                      label="備考"
                      variant="outlined"
                      className="InsText"
                      InputLabelProps={{ shrink: true }}
                      {...register("inspection_remark")}
                      error={"inspection_remark" in errors}
                      helperText={errors.inspection_remark?.message}
                      multiline={true}
                      rows={4}
                    />
                  </div>
                </td>
                <td className="tg-0lax" rowSpan={length}>
                  <div></div>
                  <label htmlFor="raised-button-file">
                    <Button
                      style={{ color: "#fff", backgroundColor: "#FFA500" }}
                      variant="contained"
                      size="large"
                    >
                      アップロードファイル選択
                      <input
                        type="file"
                        name="file"
                        className="inputFileBtnHide"
                        onChange={changeHandlerUp}
                      />
                    </Button>
                  </label>
                  <Box sx={{ p: 2, height: 200, border: "1px dashed grey" }}>
                    {isFilePicked ? (
                      <p>ファイル名: {file_name}</p>
                    ) : (
                      <p>
                        「アップロード」より選択したファイルをアップロードしてください。
                      </p>
                    )}
                    <Box sx={{ alignItems: "center", textAlign: "center" }}>
                      <Box sx={{ m: 1, position: "relative" }}>
                        <Button
                          color="primary"
                          variant="contained"
                          size="large"
                          disabled={faile_up_get}
                          onClick={upSubmit}
                        >
                          アップロード
                        </Button>
                        {Uploading && (
                          <CircularProgress
                            size={24}
                            sx={{
                              color: green[500],
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              marginTop: "-12px",
                              marginLeft: "-12px",
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  </Box>
                  <div className="textBoxDoc">
                    {fileposts.map((row, index) => (
                      <Paper className={classes.doc_paper} key={index}>
                        <a onClick={() => DLCheckSubmit(row.file_id)} href="#">
                          {row.file_name}
                        </a>
                        {"　"}
                        <IconButton
                          aria-label="delete"
                          size="small"
                          onClick={onClickDeleteDocumentIcon({
                            fileId: row.file_id,
                            fileName: row.file_name,
                          })}
                        >
                          <DeleteIcon
                            fontSize="inherit"
                            sx={{ color: pink[500] }}
                          />
                        </IconButton>
                      </Paper>
                    ))}
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        <Stack spacing={3} margin={2}></Stack>
        <Stack spacing={0} margin={0}>
          <Grid container spacing={0}>
            <Grid item xs={2} className="btnIn">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={loading}
                    size="large"
                    type="submit"
                  >
                    完了
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    className="btnlink"
                    color="primary"
                    variant="contained"
                    size="large"
                    component={Link}
                    to={{
                      pathname: "/Inspectiondetail",
                      state: { Insid: Insid, conid: conid },
                    }}
                  >
                    キャンセル
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </form>
    </GenericTemplate>
  );
};
export default Inspectionedit;
